export default {
    Get: {
        GET_SENDEMAIL:'getSendEmail',
        GET_PREVIEW_EMAIL:'getPreviewEmail',
        CHANGE_INFO_SENDEMAIL: 'changeInfoSendEmail',
        DEMAND_INFOS: 'getDemandInfo',
        PERSON_INFOS: 'getPersonInfo',
        DESINGED_MESSAGE_TEMPLATES: 'getDesignedMessageTemplates',
    },
    Set: {
        INIT_SENDEMAIL: 'initSendEmail',
        STORE_SENDEMAIL: 'insertSendEmail',
        UPDATE_SENDEMAIL: 'updateSendEmail',
        UPDATE_iTEM_ARRAY_FIELD_SENDEMAIL: 'updateArrayFieldSendEmail',
        PUSH_iTEM_ARRAY_FIELD_SENDEMAIL: 'pushItemToArrayFieldSendEmail',
        REMOVE_ITEM_ARRAY_FIELD_SENDEMAIL: 'removeItemToArrayFieldSendEmail',
        DELETE_SENDEMAIL: 'deleteSendEmail',
        POST_DATA_SENDEMAIL: 'postDataSendEmail',
        DEMAND_INFOS: 'setDemandInfos',
        PREVIEW_ATTACHMENT: 'setPreviewAttachment',
        PERSON_INFOS: 'setPersonInfo',
        DESINGED_MESSAGE_TEMPLATES: 'setDesignedMessageTemplates',
    },
    Service: {
        CHANGE_INFO_SENDEMAIL: 'changeInfoSendEmail', //{info} (INIT, MEDIA, USER, PROPERTY, MESSAGE) 
        SEND_SENDEMAIL: 'sendMessage',
        SEND_PREVIEW_EMAIL: 'previewMessage',
        CHECK_STATUS_SENDEMAIL: 'sendMessage',
        PREVIEW_ATTACHMENT: 'sendPrintTemplate',
        DESINGED_MESSAGE_TEMPLATES: 'getDesignedMessageTemplates'
    }
};